import moment from 'moment';

export const SELF_DELIVERY_INVOICES_PERIODS = {
  LAST_3_MONTHS: 0,
  LAST_6_MONTHS: 1,
  ALL_TIME: 2
};

export const SELF_DELIVERY_INVOICES_PERIOD_OPTIONS = [
  {value: SELF_DELIVERY_INVOICES_PERIODS.LAST_3_MONTHS, label: 'Last 3 months'},
  {value: SELF_DELIVERY_INVOICES_PERIODS.LAST_6_MONTHS, label: 'Last 6 months'},
  {value: SELF_DELIVERY_INVOICES_PERIODS.ALL_TIME, label: 'All time'}
];

export const SELF_DELIVERY_INVOICES_PERIOD_TITLES = {
  [SELF_DELIVERY_INVOICES_PERIODS.LAST_3_MONTHS]: 'last_3_months',
  [SELF_DELIVERY_INVOICES_PERIODS.LAST_6_MONTHS]: 'last_6_months',
  [SELF_DELIVERY_INVOICES_PERIODS.ALL_TIME]: 'all_time'
};

const MONTHS_BY_PERIOD = {
  [SELF_DELIVERY_INVOICES_PERIODS.LAST_3_MONTHS]: 3,
  [SELF_DELIVERY_INVOICES_PERIODS.LAST_6_MONTHS]: 6
};

// Calendar-aligned charge-date range in the location's timezone; [null, null] = all time.
export const getSelfDeliveryInvoicesDateRange = (
  periodIndex,
  timezoneOffset
) => {
  const months = MONTHS_BY_PERIOD[periodIndex];
  if (!months) {
    return [null, null];
  }
  const now = moment().utcOffset(timezoneOffset || 0, false);
  return [
    now
      .clone()
      .subtract(months - 1, 'months')
      .startOf('month')
      .format('YYYY-MM-DD'),
    now.clone().endOf('month').format('YYYY-MM-DD')
  ];
};
